module.exports = __webpack_public_path__ + "static/media/howLongRecommended.d48588d9.mp3";